import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { setNoteNumber } from "../../helper/calculation";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import { BSTableDND } from "./TableDND/Table";
import swal from "sweetalert";

import commoncss from "../../myfin_v2/css/common.module.css";
import tablecss from "../../myfin_v2/css/table.module.css";
import GroupingDrilldownTable from "./GroupingDrilldownTable"
import sampleData from "./sample3.json";
import { getMappingDataApiHandler } from "../../services/api/apiHandler";

const BalanceSheet = (props) => {
  const { projectData, setTempValue, hideData, hideChildData, setAddNoteGrp } = props;
  const [no, setNo] = useState([]);
  const { isSuccess, response, error_message, loading } = useSelector((state) => state.TempTabBSReducer)
  const rows = response?.balance_sheet ?? [];
  const fsRows = Object.keys(rows);
  const [bsData, setBSData] = useState(null);



  useEffect(() => {
    setNo(setNoteNumber(fsRows, rows));
  }, []);

  useEffect(() => {
    if (projectData?._id) {
      getMappingData();
    }
  }, projectData)

  const getIndexNumber = (line) => {
    try {
      let index = no.findIndex((note) => note?.notes_grp.toLowerCase() === line?.notes_grp.toLowerCase());
      return index += 2

    } catch (err) {
      console.log("error", err.message)
      return "00"
    }

  }

  const getMappingData = () => {
    const getParams = {
      projectID: projectData._id,
    };
    getMappingDataApiHandler(getParams)
      .then((response) => {
        if (response?.data?.success === true) {
          const respData = response?.data;
          setBSData(respData.grouping.filter(item => item.category === "BS"))
        } else {
          swal(
            "Error",
            "Unable in getting mapping data",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          response?.data?.error || "Unable in getting mapping data",
          "error"
        );
      });
  };

  function handleClick(key) {
    setTempValue(key);
  }

  const TotalNoteGroupsValue = (group, type) => {
    try {
      if (!["cy", "py"].includes(type)) return 0;
      return response.balance_sheet[group].reduce((num, acc) => num + acc[type], 0);
    } catch (err) {
      console.log("err total notegrp", err);
      return 0
    }

  }

  return (
    <>
      {loading ? (
        <div className={tablecss.tableContainer} style={{ height: "-webkit-available", overflowY: "auto" }} >
          <Spinner animation="grow" size="sm" />
          <Spinner animation="grow" style={{ margin: "1rem" }} />
          <Spinner animation="grow" size="sm" />
        </div>
      ) : isSuccess ? (
        <>
          <>
            <div className={tablecss.tableContainer} style={{ height: "-webkit-available", overflowY: "auto" }} >
              {/* <BSTableDND
                headerData={['Particulars', 'Notes', `As at ${moment(projectData?.current_year).format("DD MMMM YYYY")}`, `As at ${moment(projectData?.previous_year).format("DD MMMM YYYY")}`]}
                groupData={fsRows}
                tableData={rows}
                handleClick={handleClick}
                TotalNoteGroupsValue={TotalNoteGroupsValue}
                companyType={response.company_type}
                setAddNoteGrp={setAddNoteGrp}
              /> */}
              {bsData && (
                <GroupingDrilldownTable grouping={bsData} />
              )}

            </div>
          </>
        </>
      ) :
        (
          <p className="text-danger">
            {error_message || "Something went wrong!!!"}
          </p>
        )
      }
    </>
  );
};

export default BalanceSheet;
